import { Grid, makeStyles, Typography } from "@material-ui/core";
import { useState } from "react";
import { Button, TextButton } from "../../../../components/base";
import { ActionButtonsGroup } from "../../../../components/buttonsGroup/ActionButtonsGroup";
import { useSelector } from "react-redux";
import { EmptyPage } from "../../../../components/parts";
import { tenantListFormatter } from "./tenantsList/tenantListFormatter";
import { TenantsList } from "./tenantsList";

const useStyles = makeStyles((theme) => ({
  headerContainer: {
    marginTop: theme.spacing(2.5),
    marginBottom: theme.spacing(2),
  },
  listName: {
    fontWeight: "bold",
    marginRight: theme.spacing(1),
  },
  buttonsGroup: {
    marginLeft: theme.spacing(4),
    marginRight: theme.spacing(3),
  },
}));

export const List = ({ onBack }) => {
  const classes = useStyles();
  const [selectedObj, setSelectedObj] = useState(null);
  const [hasFilter, setHasFilter] = useState(null);
  const { user } = useSelector((state) => state.auth);

  const backToMain = () => {
    if (selectedObj) {
      setSelectedObj(null);
    } else {
      onBack(false);
    }
  };

  const { tenantsListData } = useSelector((state) => state.tenants);

  return (
    <>
      <Grid
        className={classes.headerContainer}
        container
        justifyContent="space-between"
        alignItems="center"
      >
        <Grid container style={{ width: "fit-content" }}>
          <Typography className={classes.listName}>
            {`TENANTS LIST (${tenantsListData?.reduce(
              (total, property) => total + property.tenants.length,
              0
            )})`}
          </Typography>

          {!selectedObj && (
            <TextButton text="Clear filters" normalFontWeight onClick={() => setHasFilter(false)} />
          )}
        </Grid>
        <Grid container alignItems="center" style={{ width: "fit-content" }}>
          <div className={classes.buttonsGroup}>
            <ActionButtonsGroup hideIntegrateBtn />
          </div>
          <Button text="BACK TO MAIN" onClick={backToMain} />
        </Grid>
      </Grid>

      {tenantsListData?.length ? (
        <TenantsList
          tenants={tenantsListData}
          onSelected={setSelectedObj}
          hasFilter={hasFilter}
          setHasFilter={setHasFilter}
          formatter={() => tenantListFormatter(user?.unit_system)}
          propertyFlag={false}
        />
      ) : (
        <EmptyPage headerText="tenants" footerText="Tenancy" />
      )}
    </>
  );
};
